export default __webpack_public_path__ + "static/Rhyme8-15aa95d05892134ef7ba033ce869f9df.mp3";